var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-root"},[_c('div',{staticClass:"d-flex flex-row-fluid flex-column bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-sm-30",style:({
      backgroundImage: ("url(" + _vm.backgroundImage + ")")
    })},[_c('h1',{staticClass:"font-size-h1 font-weight mt-35 text-dark"},[_vm._v(" Hubungi Wellmagic Media Digital ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }